import type { SwimlaneCategory } from '@patrianna/shared-patrianna-types/store/GameModule'

import { IS_BRAND_PULSZBINGO } from 'config/brands'

export const shouldShowNotAvailableLocation = (categories: SwimlaneCategory[] | string[]) => {
  return IS_BRAND_PULSZBINGO ? categories.length < 2 : !categories.length
}
